import Cookies from 'js-cookie';
import axios from "axios";
import { get } from 'lodash';
import { setLoad } from "../../main";

const getDefaultState = () => {
  return {
    // retention_j_sales: [],
    // retention_fo_sales: [],
    // retention_sales: [],
    // sales: [],
    agentsCrmIdsPerBoard: [],
    collectives: {},
    boards: {},
    useNewVersion: false,
    active: Cookies.get('activeBoardName') ? Cookies.get('activeBoardName') : null,
  }
}


const state = getDefaultState();

const mutations = {
  setActiveBoard: (state, boardName) => {
    state.active = boardName;
    Cookies.set('activeBoardName', boardName)
  },
  removeActiveBoard: (state) => {
    state.active = null;
    Cookies.remove('activeBoardName')
  },
  setBoards: (state, boards) => {
    // state.retention_fo_sales = retention_fo_sales;
    // state.retention_sales = retention_sales;
    // state.sales = sales;
    state.boards = boards;
  },
  setCollectives: (state, collectives) => {
    state.collectives = collectives;
  },
  setAgentsCrmIdsPerBoard: (state, crmIds) => {
    state.agentsCrmIdsPerBoard = crmIds || [];
  },
  setUseNewVersion: (state, useNewVersion) => {
    state.useNewVersion = !!useNewVersion;
  },
  replace(state, data) {
    state.socket = 1;

    Object.assign(state, data.data);

    if (Object.prototype.hasOwnProperty.call(data.data, 'use_new_version')) {
      state.useNewVersion = !!data.data.use_new_version;
    }

    // Object.assign(state.retention_fo_sales, data.data.retention_fo_sales);
    // Object.assign(state.retention_sales, data.data.retention_sales);
    // Object.assign(state.sales, data.data.sales);
    // Object.assign(state.sales, data.data.retention_j_sales);
  }
};

const actions = {
  getBoards: ({ commit }) => {
    return axios(
      { url: 'sync/streams/sale_boards_settings_stream', method: 'GET' }
    ).then((resp) => {
      const boardRequestAutoFill = (board) => ({
        name: get(board, 'name', ''),
        type: get(board, 'type', 'retention_sales'),
        link: get(board, 'link', ''),
        is_slider: get(board, 'is_slider', false),
        default_role: get(board, 'default_role', ''),
        slide_timeout: get(board, 'slide_timeout', 0),
        active: get(board, 'active', false),
        pages: (get(board, 'pages', []) || []).map(page => ({
          title: get(page, 'title', ''),
          type: get(page, 'type', 'background_page'),
          position: get(page, 'position', 0),
          back_img: get(page, 'back_img', ''),
          active: get(page, 'active', false),
          value: (get(page, 'value', []) || []).map(val => ({
            widget: {
              type: get(val, ['widget', 'type'], ''),
              pos_x: get(val, ['widget', 'pos_x'], 0),
              pos_y: get(val, ['widget', 'pos_y'], 0),
              cols: get(val, ['widget', 'cols'], 0),
              rows: get(val, ['widget', 'rows'], 0),
              value: get(val, ['widget', 'value'], {}) || {},
              board_id: get(board, 'id', 0)
            }
          })),
        }))
      });

      // let { retention_fo_sales, retention_sales, sales } = resp.data.data;

      const newBoards = {};

      for (let board in resp.data.data) {
          newBoards[board] = boardRequestAutoFill(resp.data.data[board])
      }

      commit('setBoards', newBoards);
      commit('setCollectives', resp.data.collectives);
      commit('setUseNewVersion', resp.data.use_new_version);

      setLoad(0);

    });
  },
};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
